import React from 'react';
import ReactDOM from 'react-dom/client';
// i18n must be imported before App so the i18next instance is initialised
// before any component calls useTranslation().
import './i18n';
import './styles/tokens.css';
import { App } from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { PublicSchedulePage } from './pages/public/PublicSchedulePage';
import { PublicSetcardPage } from './pages/public/PublicSetcardPage';

// US-006: Öffentlicher, PIN-geschützter Tagesplan (`/tagesplan/{token}`).
// Alt-Pfad `/stundenplan/{token}` bleibt für bereits verschickte Links gültig.
// Wird VOR dem Auth-Gate gerendert — Kunden haben keinen CRM-Login.
const publicScheduleMatch = /^\/(?:tagesplan|stundenplan)\/([^/]+)\/?$/.exec(window.location.pathname);

// US-PB-SETCARD: Öffentliche, PIN-geschützte Setcard (`/setcard/{token}`).
// Wird VOR dem Auth-Gate gerendert — Empfänger haben keinen CRM-Login.
const publicSetcardMatch = /^\/setcard\/([^/]+)\/?$/.exec(window.location.pathname);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider>
      {publicScheduleMatch ? (
        <PublicSchedulePage token={decodeURIComponent(publicScheduleMatch[1])} />
      ) : publicSetcardMatch ? (
        <PublicSetcardPage token={decodeURIComponent(publicSetcardMatch[1])} />
      ) : (
        <AuthProvider>
          <PermissionsProvider>
            <App />
          </PermissionsProvider>
        </AuthProvider>
      )}
    </ThemeProvider>
  </React.StrictMode>
);
